// Original Package: https://github.com/CenterForTheBuiltEnvironment/pythermalcomfort
// When vr>0.1, PMV is effected by Cooling Effect
// Then PMV = pmv_ppd_optimized(tdb=tdb-ce, tr=tr-ce, vr=0.1, rh=rh, met=met, clo_d=clo_d, wme=0)


function pmvcalculation() {

  this.v_relative = function(v, met){
    if (met > 1){
      let vr = v + 0.3 * (met - 1);
      return vr;
    }
    else{
      return v;
    }
  }
  

  this.clo_dynamic = function(clo, met){
    if (met > 1.2){
      clo_d = clo * (0.6 + 0.4 / met);
      return clo_d;
    }
    else{
      return clo;
    }
  }


  this.p_sat_torr = function (tdb){
    // Estimates the saturation vapor pressure in [torr]
    // Returns -  p_sat  : float | saturation vapor pressure [torr]
    let p_sat_torr = Math.exp(18.6686 - 4030.183 / (tdb + 235.0));
    return p_sat_torr;
  }


  // [two_nodes_optimized] calculates the Standard Effective Temperature (SET)
  // When the SET is used to calculate the Cooling Effect: v=vr, clo=clo_d, calculate_ce=true
  // Otherwise, v=v, clo=clo, calculate_ce=false. Then the value will be the same as the CBE website shows in SET.
  this.two_nodes_optimized =function(tdb, tr, v, vapor_pressure, met, clo, wme, body_position, calculate_ce){

    // Default value
    body_surface_area = 1.8258;
    p_atmospheric = 101325;
    max_skin_blood_flow= 90
    max_sweating=500
    
    // Initial variables as defined in the ASHRAE 55-2020
    air_speed = Math.max(v, 0.1)
    k_clo = 0.25
    body_weight = 70  // body weight in kg
    met_factor = 58.2  // met conversion factor
    sbc = 0.000000056697  // Stefan-Boltzmann constant (W/m2K4)
    c_sw = 170  // driving coefficient for regulatory sweating
    c_dil = 200  // driving coefficient for vasodilation ashrae says 50 see page 9.19
    c_str = 0.5  // driving coefficient for vasoconstriction
  
    temp_skin_neutral = 33.7
    temp_core_neutral = 36.8
    alfa = 0.1
    temp_body_neutral = alfa * temp_skin_neutral + (1 - alfa) * temp_core_neutral
    skin_blood_flow_neutral = 6.3
  
    t_skin = temp_skin_neutral
    t_core = temp_core_neutral
    m_bl = skin_blood_flow_neutral
    
    // initialize some variables
    e_skin = 0.1 * met  // total evaporative heat loss, W
    q_sensible = 0  // total sensible heat loss, W
    w = 0  // skin wettedness
    _set = 0  // standard effective temperature
    e_rsw = 0  // heat lost by vaporization sweat
    e_diff = 0  // vapor diffusion through skin
    e_max = 0  // maximum evaporative capacity
    m_rsw = 0  // regulatory sweating
    q_res = 0  // heat loss due to respiration
    et = 0  // effective temperature
    e_req = 0  // evaporative heat loss required for tmp regulation
    r_ea = 0
    r_ecl = 0
    c_res = 0  // convective heat loss respiration
  
    pressure_in_atmospheres = p_atmospheric / 101325
    length_time_simulation = 60  // length time simulation
    n_simulation = 0
  
    r_clo = 0.155 * clo  // thermal resistance of clothing, C M^2 /W
    f_a_cl = 1.0 + 0.15 * clo  // increase in body surface area due to clothing
    lr = 2.2 / pressure_in_atmospheres  // Lewis ratio
    rm = (met - wme) * met_factor  // metabolic rate
    m = met * met_factor  // metabolic rate
  
    e_comfort = 0.42 * (rm - met_factor)  // evaporative heat loss during comfort
    
    if (e_comfort < 0){
      e_comfort = 0
    }
    if (clo <= 0){
      w_max = 0.38 * Math.pow(air_speed, -0.29)  // critical skin wettedness
      i_cl = 1.0  // permeation efficiency of water vapour through the clothing layer
    }
    else{
      w_max = 0.59 * Math.pow(air_speed, -0.08)  // critical skin wettedness
      i_cl = 0.45  // permeation efficiency of water vapour through the clothing layer
    }
  
    // h_cc corrected convective heat transfer coefficient
    h_cc = 3.0 * Math.pow(pressure_in_atmospheres, 0.53)
    // h_fc forced convective heat transfer coefficient, W/(m2 °C)
    h_fc = 8.600001 * Math.pow((air_speed * pressure_in_atmospheres), 0.53)
    h_cc = Math.max(h_cc, h_fc)
  
    if (calculate_ce === false && met > 0.85){
      h_c_met = 5.66 * (met - 0.85) ** 0.39
      h_cc = Math.max(h_cc, h_c_met)
    }
  
    h_r = 4.7  // linearized radiative heat transfer coefficient
    h_t = h_r + h_cc  // sum of convective and radiant heat transfer coefficient W/(m2*K)
    r_a = 1.0 / (f_a_cl * h_t)  // resistance of air layer to dry heat
    t_op = (h_r * tr + h_cc * tdb) / h_t  // operative temperature
  
    t_body = alfa * t_skin + (1 - alfa) * t_core  // mean body temperature, °C
    
    // respiration
    q_res = 0.0023 * m * (44.0 - vapor_pressure)  // latent heat loss due to respiration
    c_res = 0.0014 * m * (34.0 - tdb)  // sensible convective heat loss respiration
  
    while (n_simulation < length_time_simulation){
      n_simulation += 1
      iteration_limit = 150  // for following while loop
      
      // t_cl temperature of the outer surface of clothing
      t_cl = (r_a * t_skin + r_clo * t_op) / (r_a + r_clo)  // initial guess
      n_iterations = 0
      tc_converged = false
  
      while (tc_converged === false){
        // 0.95 is the clothing emissivity from ASHRAE fundamentals Ch. 9.7 Eq. 35
        if (body_position === "sitting"){
          // 0.7 ratio between radiation area of the body and the body area
          h_r = 4.0 * 0.95 * sbc * ((t_cl + tr) / 2.0 + 273.15) ** 3.0 * 0.7
        }
        else{
          // if standing
          // 0.73 ratio between radiation area of the body and the body area
          h_r = 4.0 * 0.95 * sbc * ((t_cl + tr) / 2.0 + 273.15) ** 3.0 * 0.73
        }
        h_t = h_r + h_cc
        r_a = 1.0 / (f_a_cl * h_t)
        t_op = (h_r * tr + h_cc * tdb) / h_t
        t_cl_new = (r_a * t_skin + r_clo * t_op) / (r_a + r_clo)
  
        if (Math.abs(t_cl_new - t_cl) <= 0.01){
          tc_converged = true
        }    
        t_cl = t_cl_new
        n_iterations += 1
  
        if (n_iterations > iteration_limit){
          throw StopIteration;
        }
      }
      
      q_sensible = (t_skin - t_op) / (r_a + r_clo)  // total sensible heat loss, W
      // hf_cs rate of energy transport between core and skin, W
      // 5.28 is the average body tissue conductance in W/(m2 C)
      // 1.163 is the thermal capacity of blood in Wh/(L C)
      hf_cs = (t_core - t_skin) * (5.28 + 1.163 * m_bl)
      s_core = m - hf_cs - q_res - c_res - wme  // rate of energy storage in the core
      s_skin = hf_cs - q_sensible - e_skin  // rate of energy storage in the skin
      tc_sk = 0.97 * alfa * body_weight  // thermal capacity skin
      tc_cr = 0.97 * (1 - alfa) * body_weight  // thermal capacity core
      d_t_sk = (s_skin * body_surface_area) / (tc_sk * 60.0)  // rate of change skin temperature °C per minute
      d_t_cr = (s_core * body_surface_area / (tc_cr * 60.0))  // rate of change core temperature °C per minute
      t_skin = t_skin + d_t_sk
      t_core = t_core + d_t_cr
      t_body = alfa * t_skin + (1 - alfa) * t_core
      // sk_sig thermoregulatory control signal from the skin
      sk_sig = t_skin - temp_skin_neutral
      warm_sk = (sk_sig > 0) * sk_sig  // vasodilation signal
      colds = ((-1.0 * sk_sig) > 0) * (-1.0 * sk_sig)  // vasoconstriction signal
      // c_reg_sig thermoregulatory control signal from the skin, °C
      c_reg_sig = t_core - temp_core_neutral
      // c_warm vasodilation signal
      c_warm = (c_reg_sig > 0) * c_reg_sig
      // c_cold vasoconstriction signal
      c_cold = ((-1.0 * c_reg_sig) > 0) * (-1.0 * c_reg_sig)
      // bd_sig thermoregulatory control signal from the body
      bd_sig = t_body - temp_body_neutral
      warm_b = (bd_sig > 0) * bd_sig
      m_bl = (skin_blood_flow_neutral + c_dil * c_warm) / (1 + c_str * colds)
  
      if (m_bl > max_skin_blood_flow){
        m_bl = max_skin_blood_flow
      }   
      if (m_bl < 0.5){
        m_bl = 0.5
      }
      m_rsw = c_sw * warm_b * Math.exp(warm_sk / 10.7)  // regulatory sweating
      if (m_rsw > max_sweating){
        m_rsw = max_sweating
      }
      e_rsw = 0.68 * m_rsw  // heat lost by vaporization sweat
      r_ea = 1.0 / (lr * f_a_cl * h_cc)  // evaporative resistance air layer
      r_ecl = r_clo / (lr * i_cl)
      e_req = rm - q_res - c_res - q_sensible  // evaporative heat loss required for tmp regulation
      e_max = (Math.exp(18.6686 - 4030.183 / (t_skin + 235.0)) - vapor_pressure) / (r_ea + r_ecl)
      p_rsw = e_rsw / e_max  // ratio heat loss sweating to max heat loss sweating
      w = 0.06 + 0.94 * p_rsw  // skin wetness
      e_diff = w * e_max - e_rsw  // vapor diffusion through skin
  
      if (w > w_max){
        w = w_max
        p_rsw = w_max / 0.94
        e_rsw = p_rsw * e_max
        e_diff = 0.06 * (1.0 - p_rsw) * e_max
      }
      if (e_max < 0){
        e_diff = 0
        e_rsw = 0
        w = w_max
      }
  
      e_skin = e_rsw + e_diff   // total evaporative heat loss sweating and vapor diffusion
      met_shivering = 19.4 * colds * c_cold  // met shivering W/m2
      m = rm + met_shivering
      alfa = 0.0417737 + 0.7451833 / (m_bl + 0.585417)
    }
      
    q_skin = q_sensible + e_skin  // total heat loss from skin, W
    // p_s_sk saturation vapour pressure of water of the skin
    p_s_sk = Math.exp(18.6686 - 4030.183 / (t_skin + 235.0))
  
    // standard environment - where _s at end of the variable names stands for standard
    h_r_s = h_r  // standard environment radiative heat transfer coefficient
  
    h_c_s = 3.0 * Math.pow(pressure_in_atmospheres, 0.53)
    if (calculate_ce === false && met > 0.85){
      h_c_met = 5.66 * (met - 0.85) ** 0.39
      h_c_s = Math.max(h_c_s, h_c_met)
    }
    
    if (h_c_s < 3.0){
      h_c_s = 3.0
    }
  
    h_t_s = h_c_s + h_r_s   // sum of convective and radiant heat transfer coefficient W/(m2*K)
    r_clo_s = 1.52 / ((met - wme / met_factor) + 0.6944) - 0.1835  // thermal resistance of clothing, °C M^2 /W
    r_cl_s = 0.155 * r_clo_s  // thermal insulation of the clothing in M2K/W
    f_a_cl_s = 1.0 + k_clo * r_clo_s  // increase in body surface area due to clothing
    f_cl_s = 1.0 / (1.0 + 0.155 * f_a_cl_s * h_t_s * r_clo_s)  // ratio of surface clothed body over nude body
    i_m_s = 0.45  // permeation efficiency of water vapour through the clothing layer
    i_cl_s = i_m_s * h_c_s / h_t_s * (1 - f_cl_s) / (h_c_s / h_t_s - f_cl_s * i_m_s)  // clothing vapor permeation efficiency
    r_a_s = 1.0 / (f_a_cl_s * h_t_s)  // resistance of air layer to dry heat
    r_ea_s = 1.0 / (lr * f_a_cl_s * h_c_s)
    r_ecl_s = r_cl_s / (lr * i_cl_s)
    h_d_s = 1.0 / (r_a_s + r_cl_s)
    h_e_s = 1.0 / (r_ea_s + r_ecl_s)
  
    // calculate Standard Effective Temperature (SET) 
    delta = 0.0001
    dx = 100.0
    set_old = (t_skin - q_skin / h_d_s) 
    
    while (Math.abs(dx) > 0.01){
      err_1 = (
        q_skin
        - h_d_s * (t_skin - set_old)
        - w
        * h_e_s
        * (p_s_sk - 0.5 * (Math.exp(18.6686 - 4030.183 / (set_old + 235.0))))
      )
      err_2 = (
        q_skin
        - h_d_s * (t_skin - (set_old + delta))
        - w
        * h_e_s
        * (p_s_sk - 0.5 * (Math.exp(18.6686 - 4030.183 / (set_old + delta + 235.0))))
      )
      _set = set_old - delta * err_1 / (err_2 - err_1)
      dx = _set - set_old
      set_old = _set
    }

   return _set

  }
  
  // Required Further Input //
  // I have tested all the result of function and think the main reason for calculation error is due to the bisection function
  // In some special cases, when MET=2(walking fast), the bisection function didn't narrow down enough. CE should be 6, but get 9
  this.cooling_effect =function(tdb, tr, vr, rh, met, clo_d, wme, body_position, calculate_ce=true){
    let EPSILON = 0.01;
    let still_air_threshold = 0.1;
    let vapor_pressure = rh * this.p_sat_torr(tdb) / 100;

    if(vr <= 0.1){
      return 0;
    }   // When vr=0.1, Don't calculate CE
    
    let initial_set_tmp = this.two_nodes_optimized(
      tdb=tdb,
      tr=tr,
      v=vr,
      vapor_pressure = vapor_pressure,
      met=met,
      clo=clo_d,
      wme=wme,
      body_position,
      calculate_ce=true
      );
     
    // An example function whose solution is determined using
    let cache={}
    this.func = function(x){
      if (cache[x]){
        return cache[x]
      } else {
        let result =this.two_nodes_optimized(
                tdb - x,
                tr - x,
                v=still_air_threshold,
                vapor_pressure = vapor_pressure,
                met=met,
                clo=clo_d,
                wme=wme,
                body_position,
                calculate_ce=true
            )
            - initial_set_tmp
        cache[x]=result
        return result
      }
    }
     
    // Prints root of func(x) with error of EPSILON
    this.bisection = function(a, b){

      if (this.func(a) * this.func(b) >= 0){
        return 0;
      }

      let c = a;
      while ((b-a) >= EPSILON){
        // Find middle point
        c = (a+b)/2;
        // Check if middle point is root
        let resultForC=this.func(c)
        if (resultForC == 0.0){
          break;
        }
        // Decide the side to repeat the steps
        else if (resultForC * this.func(a) < 0){
          b = c;}
        else{
          a = c;}
        }
      return c;
    }
    let CE = this.bisection(0, 15);
    return CE;

  }
  
  
  this.pmv_ppd_optimized = function(tdb_ce, tr_ce, vr_ce, rh, met, clo_d, wme){
    
    pa = rh * 10 * Math.exp(16.6536 - 4030.183 / (tdb_ce + 235))
    icl = 0.155 * clo_d  // thermal insulation of the clothing in M2K/W
    m = met * 58.15  // metabolic rate in W/M2
    w = wme * 58.15  // external work in W/M2
    mw = m - w  // internal heat production in the human body

    // calculation of the clothing area factor
    if (icl <= 0.078){
      f_cl = 1 + (1.29 * icl); // ratio of surface clothed body over nude body
    }
    else {
      f_cl = 1.05 + (0.645 * icl);
    }
  
    // heat transfer coefficient by forced convection
    hcf = 12.1 * Math.sqrt(vr_ce)
    hc = hcf  // initialize variable
    taa = tdb_ce + 273
    tra = tr_ce + 273
    t_cla = taa + (35.5 - tdb_ce) / (3.5 * icl + 0.1)
    
    p1 = icl * f_cl
    p2 = p1 * 3.96
    p3 = p1 * 100
    p4 = p1 * taa
    p5 = (308.7 - 0.028 * mw) + (p2 * (tra / 100.0) ** 4)
    xn = t_cla / 100
    xf = t_cla / 50
    eps = 0.00015
    
    n = 0
    
    while (Math.abs(xn -xf) > eps) {
      xf = (xf + xn) / 2;
      hcn = 2.38 * Math.abs(100.0 * xf - taa) ** 0.25;
      if (hcf > hcn) {
        hc = hcf
      }
      else { hc = hcn }
      xn = (p5 + p4 * hc - p2 * xf ** 4) / (100 + p3 * hc)
      n += 1
      
      if (n > 150) {
        throw StopIteration ("Max iterations exceeded")
      }
    }

    tcl = 100 * xn - 273
    
    // heat loss diff. through skin
    hl1 = 3.05 * 0.001 * (5733 - (6.99 * mw) - pa)
    
    // heat loss by sweating
    if (mw > 58.15) {
      hl2 = 0.42 * (mw - 58.15);
    }
    else {
      hl2 = 0;
    }
    
    // latent respiration heat loss
    hl3 = 1.7 * 0.00001 * m * (5867 - pa)
    // dry respiration heat loss
    hl4 = 0.0014 * m * (34 - tdb_ce)
    // heat loss by radiation
    hl5 = 3.96 * f_cl * (xn ** 4 - (tra / 100.0) ** 4)
    // heat loss by convection
    hl6 = f_cl * hc * (tcl - tdb_ce)

    ts = 0.303 * Math.exp(-0.036 * m) + 0.028
    
    _pmv = ts * (mw - hl1 - hl2 - hl3 - hl4 - hl5 - hl6)
    return _pmv
  }


  this.pmv_withCE = function(tdb, tr, v, rh, met, clo, wme, body_position){
    let ce = 0;
    let vr = this.v_relative(v, met);
    let clo_d = this.clo_dynamic(clo, met);

    if(vr >= 0.1){
      calculate_ce = true;
      ce = this.cooling_effect(tdb, tr, vr, rh, met, clo_d, wme, body_position, calculate_ce);
    }   // When vr=0.1, Don't calculate CE. Set up this for including the case when vr=0.1
    if (ce > 0){
      vr = 0.1;
    }
    
    let tbd_ce = tdb - ce;
    let tr_ce = tr - ce;
    let vr_ce = vr;   // vr = 0

    pmv = this.pmv_ppd_optimized(tbd_ce, tr_ce, vr_ce, rh, met, clo_d, wme);
    
    return pmv;
    
  }

  // Notice: [tdb] could effect [pmv], while [tr] could effect [comfortRange]
  // For convenience, CBE always assumes tdb=tr=25 during calculating [comfortRange]
  // The function below also assumes tdb=tr=25
  this.comfortRange = function(v, rh_cr, met, clo, wme, body_position, x){
    // rh_cr = 100 or 0
    // x = -0.5 or 0.5 PMV Value

    let EPSILON = 0.1;
    let tdb_cr = 25;
    let cache ={}
    this.pmvFormula = function(tdb_cr){
      if (cache[tdb_cr]){
        return cache[tdb_cr]
      } else {
        let result= this.pmv_withCE(tdb_cr, tdb_cr, v, rh_cr, met, clo, wme, body_position)- x;
        cache[tdb_cr] = result
        return result
      }

    }

    this.pmvBisection = function(e, f){
      if (this.pmvFormula(e) * this.pmvFormula(f) >= 0)
        {
          return 0;
        }
      
      let g = e;
      while ((f-e) >= EPSILON){
        g = (e+f)/2;
        let pmvg = this.pmvFormula(g)
        if (pmvg == 0.0){
          break;
        }
        else if (pmvg * this.pmvFormula(e) < 0){
          f = g;
        }
        else {
          e = g;
        }
      }
      return g;
    }
    let CR = this.pmvBisection(10, 40);
    return CR
  }

}





(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
      // AMD. Register as an anonymous module.
      define([], factory);
  } else if (typeof module === 'object' && module.exports) {
      // Node. Does not work with strict CommonJS, but
      // only CommonJS-like environments that support module.exports,
      // like Node.
      module.exports = factory();
  } else {
      // Browser globals (root is window)
      root.pmvCalculation = factory();
  }
}(typeof self !== 'undefined' ? self : this, function () {
  return new pmvcalculation();
}));